'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechtypeen', {
        url: '/speechtypeen',
        template: '<speechtypeen></speechtypeen>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechtypeen/speechtypeen.routes.js